import { PropsWithChildren } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { Icon, WithCommonProps } from '@shipengine/giger';
import { getCardHeadingIconStyles, getCardHeadingStyles, getCardStyles } from './CardStyles';

export type CardProps = WithCommonProps<{
    titleIcon?: IconNames;
    title?: string;
}>;

export function Card({ title, titleIcon, children, ...props }: PropsWithChildren<CardProps>): JSX.Element {
    return (
        <article css={getCardStyles} {...props}>
            {title && (
                <header css={getCardHeadingStyles}>
                    {titleIcon && <Icon css={getCardHeadingIconStyles} name={titleIcon} />}{' '}
                    <h2 className="card__title">{title}</h2>
                </header>
            )}
            <section>{children}</section>
        </article>
    );
}
